const autoNgTemplateLoaderTemplate1 = require('./logs.html');

angular.module('shbdeployer.kubernetes').component('kubernetesStackLogsView', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'KubernetesStackLogsController',
  controllerAs: 'ctrl',
  bindings: {
    $transition$: '<',
  },
});
